import { createApi } from '@reduxjs/toolkit/query/react';
import { urls } from '../../utils/helpers/ApiClient';
import axiosFetchBase from '../axiosFetchBase';

export const ingProjectsChangeRequestsApi = createApi({
  reducerPath: 'ingProjectsChangeRequestsApi',
  baseQuery: axiosFetchBase,
  tagTypes: ['IpChangeRequests', 'IpChangeRequestsCount'],
  keepUnusedDataFor: 0,
  endpoints: (builder) => ({
    getChangeRequests: builder.query({
      query: () => ({
        url: urls.ingProjectsChangeRequests,
      }),
      providesTags: ['IpChangeRequests'],
      refetchOnFocus: true,
      refetchOnReconnect: true,
    }),

    getChangeRequestsCount: builder.query({
      query: () => ({
        url: urls.ingProjectsChangeRequestsCount,
      }),
      providesTags: ['IpChangeRequestsCount'],
    }),

    getChangeRequest: builder.query({
      query: (id) => ({
        url: urls.ingProjectsChangeRequestDetail(id),
      }),
      providesTags: (result, error, id) => [{ type: 'IpChangeRequests', id }],
    }),

    createChangeRequest: builder.mutation({
      query(data) {
        return {
          url: urls.ingProjectsChangeRequests,
          method: 'POST',
          data: data,
        };
      },
      invalidatesTags: ['IpChangeRequests', 'IpChangeRequestsCount'],
    }),

    approveChangeRequest: builder.mutation({
      query(id) {
        return {
          url: urls.ingProjectsChangeRequestApprove(id),
          method: 'PUT',
        };
      },
      invalidatesTags: ['IpChangeRequests', 'IpChangeRequestsCount'],
    }),

    rejectChangeRequest: builder.mutation({
      query(id) {
        return {
          url: urls.ingProjectsChangeRequestReject(id),
          method: 'PUT',
        };
      },
      invalidatesTags: ['IpChangeRequests', 'IpChangeRequestsCount'],
    }),

    deleteChangeRequest: builder.mutation({
      query(id) {
        return {
          url: urls.ingProjectsChangeRequestDetail(id),
          method: 'DELETE',
        };
      },
      invalidatesTags: ['IpChangeRequests', 'IpChangeRequestsCount'],
    }),

    getChangeRequestApprovalByToken: builder.query({
      query: ({ action, token }) => ({
        url: urls.ingProjectsChangeRequestToken(action, token),
      }),
    }),
  }),
});

export const {
  useGetChangeRequestsQuery,
  useGetChangeRequestsCountQuery,
  useGetChangeRequestQuery,
  useCreateChangeRequestMutation,
  useApproveChangeRequestMutation,
  useRejectChangeRequestMutation,
  useDeleteChangeRequestMutation,
  useGetChangeRequestApprovalByTokenQuery,
} = ingProjectsChangeRequestsApi;
